// extracted by mini-css-extract-plugin
module.exports = {"button":"PlayPauseButton_button__1nyXY","icon":"PlayPauseButton_icon__YSaoQ","isHidden":"PlayPauseButton_isHidden__28gZd"};